exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navigation.component {\n  flex-flow: column;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.navigation.component ul {\n  flex: 1;\n}\n\n.navigation.component li {\n  box-sizing: border-box;\n  display: flex;\n  border-bottom-style: solid;\n  border-width: 2px;\n}\n\n.navigation.component .label{\n  font-family: 'OrkneyMedium', sans-serif;\n  color: #CCCCCC;\n  flex: 1;\n  font-size: 0.9em;\n  padding: 14px 12px 10px 12px;\n  box-sizing: border-box;\n  flex-wrap: nowrap;\n  background: none;\n}\n\n.navigation.component .label:hover{\n  background-color: #2a293f;\n}\n\n.navigation.component .label.active{\n  color: #FFFFFF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/navigation/navigation.css
// module id = 423
// module chunks = 0